<main>
  <authority-labs-base-dialog [dialogRef]="dialogRef" title="תוכניות">
    <section content class="content">
      <div class="progress" *ngIf="progress">
        <mat-spinner diameter="30"></mat-spinner>
        <h3>מחפש תוכניות..</h3>
      </div>
      <div *ngIf="plansFiles$ | async as items">
        <mat-list dir="ltr">
          <mat-list-item *ngFor="let item of items">
            <div matLine class="option">
              <mat-checkbox
                (change)="$event ? selection.toggle(item) : null"
                [checked]="selection.isSelected(item) || isIgnored(item.id)"
                [disabled]="isIgnored(item.id)"
                (click)="$event.stopPropagation()"
                ><span>{{ item.name }}</span></mat-checkbox
              >
              <button mat-icon-button (click)="viewFile($event, item.id)">
                <mat-icon>visibility</mat-icon>
              </button>
            </div>
          </mat-list-item>
        </mat-list>
        <h3 *ngIf="items.length === 0">תוכניות לא קיימות</h3>
      </div>
    </section>

    <button
      actions
      mat-button
      [mat-dialog-close]
      [disabled]="!canApply()"
      (click)="applySelection()"
    >
      בחר
    </button>
  </authority-labs-base-dialog>
</main>
